<template>
  <div class="flex gap-2 justify-start my-8">
    <button
      v-if="currentPage > 1"
      type="button"
      class="px-3 py-1 border bg-white hover:bg-gray-100"
      @click="goto(currentPage - 1)"
    >
      <svg
        width="8" height="13"
        viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="w-2 h-[0.813rem] relative right-px pointer-events-none text-gray-600 dark:text-gray-400"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        role="img"
      >
        <path
          d="M0.871094 6.14844L6.12109 0.898438C6.44922 0.542969 7.02344 0.542969 7.35156 0.898438C7.70703 1.22656 7.70703 1.80078 7.35156 2.12891L2.73047 6.75L7.35156 11.3984C7.70703 11.7266 7.70703 12.3008 7.35156 12.6289C7.02344 12.9844 6.44922 12.9844 6.12109 12.6289L0.871094 7.37891C0.515625 7.05078 0.515625 6.47656 0.871094 6.14844Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <button
      v-for="i in pageRange"
      :key="i"
      :disabled="i === currentPage"
      :class="[
        'px-3 py-1 border bg-white hover:bg-gray-100',
        i === currentPage ? 'font-medium bg-red-25! text-red-600 border-red-600 pointer-events-none' : ''
      ]"
      type="button"
      @click="goto(i)"
    >
      {{ i }}
    </button>
    <span
      v-if="endPage < numPages"
      class="px-2 text-gray-400"
    >...</span>
    <button
      v-if="currentPage < numPages"
      type="button"
      class="px-3 py-1 border bg-white hover:bg-gray-100"
      @click="goto(currentPage + 1)"
    >
      <svg
        width="8" height="13"
        viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        class="w-2 h-[0.813rem] relative left-px pointer-events-none text-gray-600 dark:text-gray-400"
        fill="none" preserveAspectRatio="xMidYMid meet"
        role="img"
      >
        <path
          d="M7.10156 6.14844C7.45703 6.47656 7.45703 7.05078 7.10156 7.37891L1.85156 12.6289C1.52344 12.9844 0.949219 12.9844 0.621094 12.6289C0.265625 12.3008 0.265625 11.7266 0.621094 11.3984L5.24219 6.75L0.621094 2.12891C0.265625 1.80078 0.265625 1.22656 0.621094 0.898438C0.949219 0.542969 1.52344 0.542969 1.85156 0.898438L7.10156 6.14844Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  currentPage: number
  numPages: number
}>()

const emit = defineEmits<{
  (e: 'goToPage', page: number): void
}>()

const startPage = computed(() => {
  let s = Math.max(1, props.currentPage - 1)
  const e = Math.min(props.numPages, s + 3)
  if (e - s < 3) s = Math.max(1, e - 3)
  return s
})

const endPage = computed(() => Math.min(props.numPages, startPage.value + 3))

const pageRange = computed(() => {
  const arr: number[] = []
  for (let i = startPage.value; i <= endPage.value; i++) arr.push(i)
  return arr
})

function goto(page: number) {
  emit('goToPage', page)
}
</script>
